/* Shared  */
import { Permission } from 'application/Shared/Components/Core';

/*  Helpers */
import { Tenant } from 'application/Shared/types/tenant';

/*  React  */
import React from 'react';

import { AddAdminUser } from './AddAdminUser';
import { LinkAnmTenant } from './LinkAnmTenant';
import { TenantActions } from './TenantActions';
import { TenantDangerZone } from './TenantDangerZone';
import { TenantFeatureFlags } from './TenantFeatureFlags';
import { UpdateWorkatoManifest } from './UploadWorkatoManifest';

export const EditTenant = ({
    tenant,
    onSuccessFn
}: {
    tenant: Tenant;
    onSuccessFn: () => void;
}) => {
    const canEditAnmLinkSettings = !!tenant.partner;

    const isClientTenant = !tenant.partner;

    return (
        <>
            <TenantActions tenant={tenant} onSuccessFn={onSuccessFn} />
            <TenantFeatureFlags tenant={tenant} onSuccessFn={onSuccessFn} />
            {canEditAnmLinkSettings && (
                <LinkAnmTenant tenant={tenant} onSuccessFn={onSuccessFn} />
            )}
            <AddAdminUser tenant={tenant} onSuccessFn={onSuccessFn} />

            {isClientTenant && (
                <Permission required="super_admin">
                    <UpdateWorkatoManifest tenant={tenant} />
                </Permission>
            )}

            <Permission required="super_admin">
                <TenantDangerZone tenant={tenant} onSuccessFn={onSuccessFn} />
            </Permission>
        </>
    );
};
